import React from 'react'
import styled from 'styled-components'

import { mediaQueries } from './Themes'
import Logo from './Logo'
import Copyright from '../Copyright/Copyright'
import { Column2, ContainerBoxed } from './Grid'
import Components from '../Components'
import { useConsent } from '../../lib/consent/ConsentContext'

const Wrapper = styled.footer`
    background: ${({ theme }) => theme.colors.backgrounds.footer};
    color: ${({ theme }) => theme.colors.fonts.body};
    padding-top: 120px;
`

const FooterNavWrapper = styled.div`
  display: grid;
  padding: 0 4rem;
  justify-items: center;
  margin-top: 4rem;
  margin-bottom: 3rem;

  ${mediaQueries("Mobile")`
  `};

  ${mediaQueries("Tablet")`
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  `};
`

const Column2Center = styled(Column2)`
  text-align: center;
`

const CookieSettingsLink = styled.button`
    font-size: 1rem;
    font-family: ${({ theme }) => theme.font.body.family};
    font-weight: ${({ theme }) => theme.font.body.weight.regular};
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.footer.navLink};
    transition: all 0.30s linear;
    &:hover {
        opacity: 0.8;
    }
    text-decoration: none;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;

    ${mediaQueries("Mobile")`
        padding: 8px 16px;
    `};

    ${mediaQueries("Tablet")`
        padding: 0 16px;
    `};
`

interface FooterProps {
    navItems: any[]
}

const Footer = (props: FooterProps) => {
    const currentYear = new Date().getFullYear()
    const { setShowBanner } = useConsent()

    return (
        <Wrapper>
            <ContainerBoxed>
                <Column2Center>
                    <Logo type="dark" height="80" />
                    <FooterNavWrapper>
                        {props.navItems.map((blok) => React.createElement(Components(blok.component), { key: blok._uid, blok: blok }))}
                        <CookieSettingsLink onClick={() => setShowBanner(true)}>
                            Cookie-Einstellungen
                        </CookieSettingsLink>
                    </FooterNavWrapper>
                    <Copyright text={`© Ziegler´s Backstube ${currentYear}`} />
                </Column2Center>
            </ContainerBoxed>
        </Wrapper>
    )
}

export default Footer
